// A row of choices in one rounded track, the picked one raised: sub-tabs
// (`mode="tabs"`, ARIA tabs with arrow keys) or a filter's few values
// (`mode="toggle"`, pressed buttons). `items` is [{ id, label }];
// `value` is the picked id, or in toggle mode an array of the ids picked,
// each click handing its id to `onChange` to add or remove.
import { useRef } from "react";

export default function Tabs({ items, value, onChange, label, mode = "tabs", className = "", itemAttrs = null }) {
    const tabs = mode === "tabs";
    const refs = useRef([]);
    function onKeyDown(event, i) {
        if (!tabs) return;
        const step = event.key === "ArrowRight" ? 1 : event.key === "ArrowLeft" ? -1 : 0;
        const to = event.key === "Home" ? 0 : event.key === "End" ? items.length - 1 : step ? (i + step + items.length) % items.length : null;
        if (to === null) return;
        event.preventDefault();
        refs.current[to]?.focus();
        onChange(items[to].id);
    }
    return (
        <div
            role={tabs ? "tablist" : "group"}
            aria-label={label}
            className={`inline-flex shrink-0 items-center gap-[2px] rounded-[9px] bg-[color-mix(in_srgb,var(--ink)_6%,transparent)] p-[3px] ${className}`}
            data-tabs=""
        >
            {items.map((item, i) => {
                const on = Array.isArray(value) ? value.includes(item.id) : item.id === value;
                return (
                    <button
                        key={item.id}
                        ref={(el) => { refs.current[i] = el; }}
                        type="button"
                        role={tabs ? "tab" : undefined}
                        aria-selected={tabs ? on : undefined}
                        aria-pressed={tabs ? undefined : on}
                        tabIndex={tabs && !on ? -1 : undefined}
                        onClick={() => onChange(item.id)}
                        onKeyDown={(event) => onKeyDown(event, i)}
                        {...(itemAttrs?.(item) ?? {})}
                        className={`h-[26px] cursor-pointer whitespace-nowrap rounded-[6px] border-0 px-[11px] text-[12.5px] leading-none transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-[color:var(--green)] ${on
                            ? "bg-[color-mix(in_srgb,var(--ink)_13%,transparent)] font-medium text-[color:var(--ink)]"
                            : "bg-transparent text-[color:var(--muted)] hover:text-[color:var(--ink)]"}`}
                    >
                        {item.label}
                    </button>
                );
            })}
        </div>
    );
}
